//
//  DSKAcl.ts
//  Supernova SDK
//
//  Created by Miro Koczka.
//
export class SubscriptionProductFeatures {
    constructor(model) {
        this.free = model.free;
        this.team = model.team;
        this.company = model.company;
        this.enterprise = model.enterprise;
    }
}
